import { render, staticRenderFns } from "./BigQueryGrabber.vue?vue&type=template&id=9c99ed06&scoped=true&"
import script from "./BigQueryGrabber.vue?vue&type=script&lang=js&"
export * from "./BigQueryGrabber.vue?vue&type=script&lang=js&"
import style0 from "./BigQueryGrabber.vue?vue&type=style&index=0&id=9c99ed06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c99ed06",
  null
  
)

export default component.exports